import {TrackableEntity} from './../data/ChangeTrackable';

export class AmsContainer extends TrackableEntity {
    id: number = 0;
    containerNo: string = '';
    sealNo1: string = '';
    sealNo2: string = '';
    descCode: string = '';
    length: number = 0;
    height: number = 0;
    width: number = 0;
    type: string = '';
    status: string = '';
    serviceCode: string = '';
    amsMasterID: number = 0;
    created: string = '';
    modified: string = '';

    constructor(init?:Partial<AmsContainer>) {
        super();
        this.key=undefined;
        Object.assign(this, init);
    }
}
